import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual } from 'react-redux';
import { Stack, FontIcon, Label } from '@fluentui/react';
import { appStyles, logger, resolveThemeColors } from '../../helpers';
import { useAppSelector } from '../../store';

type Props = {
    id: string;
    activeTab: string;
    label: string;
    iconName: string;
    onClick: (id: string) => void;
};

const Tab = (props: Props) => {
    const colors = useAppSelector(resolveThemeColors, shallowEqual);

    const onTabActivated = () => {
        logger.info('onTabActivated clicked');
        props.onClick(props.id);
    };

    const getClassName = (): string => {
        return props.activeTab === props.id
            ? appStyles.globalStyles.tabsItemActive
            : appStyles.globalStyles.tabsItem;
    };

    return (
        <Stack className={getClassName()}>
            <Stack horizontalAlign="center" onClick={onTabActivated}>
                <FontIcon
                    iconName={props.iconName}
                    style={{ fontSize: 20, color: colors.icon }}
                />
                <Label className={appStyles.globalStyles.tabsLabel}>
                    {props.label}
                </Label>
            </Stack>
        </Stack>
    );
};

export default Tab;

Tab.propTypes = {
    id: PropTypes.string.isRequired,
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};
